import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/home/organisms/Meta';
import { Complete } from '@bizapp-lp/home/templates/Complete';

type CompleteState = {
  valid?: boolean;
};

export interface CompleteContactProps {
  isAllowedDirectAccess?: boolean;
}

const title =
  'HUE Works Suite お問い合わせ完了 | 株式会社ワークスアプリケーションズ';
const description =
  '株式会社ワークスアプリケーションズがご提供するHUE Works Suiteに関するお問い合わせ完了ページです。';

const CompleteContact: React.FC<CompleteContactProps> = ({
  isAllowedDirectAccess,
}) => {
  const { state } = useLocation() as { state: CompleteState };

  return isAllowedDirectAccess || state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="お問い合わせ"
        heading2="送信が完了しました"
        description={
          <>
            <span>お問い合わせいただき、ありがとうございました。</span>
            <span>確認のためお客様へ自動返信メールをお送りしております。</span>
            <span>
              弊社担当よりご連絡いたしますので、今しばらくお待ちください。
            </span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/invalid" replace />
  );
};

export default CompleteContact;
